<template>
  <header>
    <div class="inner">
      <back :to="back" v-if="back" />
      <router-link to="/">
        <logo class="logo" />
        <span class="payoff">niet zweten, niet zwemmen</span>
      </router-link>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import Back from '@/components/Back'
import Logo from '@/components/Logo'

export default {
  components: {
    Back,
    Logo
  },
  computed: {
    ...mapState({
      back: state => state.back
    })
  }
}
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 90;
  width: 100%;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);

  .inner {
    position: relative;
    width: 100%;
  }
}

.logo {
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
}

.payoff {
  position: absolute;
  top: 45px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  color: #fff;
}
</style>
